import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Helmet } from 'react-helmet';
import Button from 'component/button.component';
import juslaboreLogo from 'resource/img/logo.png';
import recorte1 from 'resource/img/recorte-1.png';
import recorte2 from 'resource/img/recorte-2.png';
import recorte3 from 'resource/img/recorte-3.png';
import recorte4 from 'resource/img/recorte-4.png';
import api from 'config/api';
import history from 'config/history';
import { toast } from 'react-toastify';
import { userUpdateCalendarToken } from 'store/action/user.action';
import { Container } from './styles';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';

export default function AboutClipping(props) {
  const [checked, setChecked] = useState(false);
  const [token, setToken] = useState(props.token);
  const [youtubeID] = useState('IHCE2RWNEQg');

  const { user, userId } = props;

  const handleChange = event => {
    setChecked(event.target.checked);
  };

  let newwindow;
  const dispatch = useDispatch();

  async function authorizeUser() {
    try {
      const { data } = await api.post('/user/calendar/auth', {});
      createPop(data.url, 'teste');
    } catch (e) {
      toast.error('Ocorreu um erro, enquanto realizando autenticação');
    }
  }

  function createPop(url, name) {
    newwindow = window.open(
      url,
      name,
      'width=600,height=700,toolbar=0,menubar=0,location=50'
    );
    if (window.focus) {
      newwindow.focus();
    }
    createTimer();
  }

  function createTimer() {
    let timer = setInterval(function() {
      if (newwindow.closed) {
        clearInterval(timer);
        const code = localStorage.getItem('code');
        if (code) {
          authenticateWithCode(code);
        } else {
          toast.error(
            'É necessário liberar acesso ao Calendar para continuar.'
          );
        }
      }
    }, 1000);
  }

  async function authenticateWithCode(code) {
    try {
      const { data } = await api.post(`/user/calendar/auth?code=${code}`, {});
      dispatch(userUpdateCalendarToken(data.refresh_token));
      history.push('/novo-recorte');
    } catch (e) {
      toast.error('Ocorreu um erro, enquanto realizando autenticação');
    }
  }

  useEffect(() => {
    setToken(props.token);
  }, [props.token]);

  function next() {
    if (user) {
      if (checked || token) {
        doNotShowAgain();
        setToken(true);
      }
      history.push('/novo-recorte');
      return;
    }
    toast.error('Você precisa estar logado para prosseguir.');
  }

  async function doNotShowAgain() {
    try {
      const { data } = await api.post(`/user/users/calendar/${userId}`);
      toast.success('A página não será mais exibida novamente.');
    } catch (e) {
      toast.error('Ocorreu um erro ao não exibir a página novamente.');
    }
  }

  return (
    <Container>
      <Helmet>
        <title>Informação sobre uso do Recorte</title>
        <meta name="description" content="Informação sobre uso do Recorte" />
        <meta name="googlebot" content="noindex, nofollow" />
      </Helmet>
      <h1>Ferramenta de Recorte</h1>
      <p>
        Se você já conhece a ferramenta Recorte, basta clicar no botão
        Prosseguir. Para não ver essa mensagem novamente marque o campo
        indicado.
      </p>
      <FormControlLabel
        style={{
          display: 'flex',
          justifyContent: 'center',
          color: 'black',
        }}
        control={<Checkbox onChange={handleChange} />}
        label="Não exibir essa página novamente"
      />
      <Button
        image={juslaboreLogo}
        onClick={() => next()}
        text="Prosseguir"
        style={{
          color: 'rgba(0, 0, 0, 0.54)',
          boxShadow: '0 1px 10px rgba(0, 0, 0, 0.2)',
          width: '35%',
          margin: '10px auto 30px auto',
          justifyContent: 'center',
        }}
      />
      <p>
        Nós preparamos uma ferramenta revolucionária para automatizar sua agenda
        trabalhista: ela se chama <strong>Recorte</strong>. Trata-se de
        funcionalidades que farão a separação das informações dos recortes
        oficiais e darão a você autonomia para definir um fluxo de trabalho, com
        datas para realizar determinada atividade, com cálculo do prazo, e opção
        de integração com sua agenda do Google Calendar.
      </p>
      <h3>Vídeo tutorial de como utilizar o Recorte</h3>
      <iframe
        style={{
          width: 700,
          height: 400,
          border: '1px solid #CCC',
          borderRadius: 5,
          marginBottom: 15,
        }}
        className="video"
        title="Youtube player"
        sandbox="allow-same-origin allow-forms allow-popups allow-scripts allow-presentation"
        allowfullscreen="allowfullscreen"
        mozallowfullscreen="mozallowfullscreen"
        msallowfullscreen="msallowfullscreen"
        oallowfullscreen="oallowfullscreen"
        webkitallowfullscreen="webkitallowfullscreen"
        src={`https://youtube.com/embed/${youtubeID}?autoplay=0`}
      ></iframe>
      <h3>Passo a passo de como utilizar o Recorte</h3>
      <p>
        O procedimento é bastante simples e composto de três passos:{' '}
        <ul style={{ marginLeft: 30 }}>
          <li>Acesso, seleção e processamento do recorte;</li>
          <li>
            Validação/preenchimento das informações e indicação do
            prosseguimento necessário;
          </li>
          <li>
            Gravação do evento no Juslabore e possibilidade de replicação no
            Google Calendar.
          </li>
        </ul>
      </p>
      <p>
        <strong>
          Primeiro passo - Acesso, seleção e processamento do recorte:
        </strong>
      </p>
      <p style={{ textAlign: 'justify', marginBottom: '5px' }}>
        Após se cadastrar e efetuar o login, acesse o link{' '}
        <a
          style={{ textDecoration: 'underline' }}
          href="https://juslabore.com.br/novo-recorte"
        >
          https://juslabore.com.br/novo-recorte
        </a>{' '}
        ou clique na opção "Novo Recorte" do menu inicial. Em seguida, cole o
        recorte no campo "Cole o recorte aqui" e clique no botão "Processar".
      </p>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          margin: '20px 0',
        }}
      >
        <Zoom>
          <img
            src={recorte1}
            style={{
              width: 700,
              border: '1px solid #CCC',
              borderRadius: 5,
            }}
          />
        </Zoom>
      </div>
      <br />
      <p>
        <strong>
          Segundo passo - Validação/preenchimento das informações e indicação do
          prosseguimento necessário:
        </strong>
      </p>
      <p style={{ textAlign: 'justify', marginBottom: '5px' }}>
        Verifique as informações extraídas do recorte, caso haja campos que não
        foram encontrados, preencha-os e indique o prosseguimento necessário,
        conforme indicado na imagem abaixo, para que a plataforma calcule a data
        de término.
      </p>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          margin: '20px 0',
        }}
      >
        <Zoom>
          <img
            src={recorte2}
            style={{ width: 700, border: '1px solid #CCC', borderRadius: 5 }}
          />
        </Zoom>
      </div>
      <br />
      <p>
        <strong>
          Terceiro passo - Gravação do evento no Juslabore e possibilidade de
          replicação no Google Calendar:
        </strong>
      </p>
      <p style={{ textAlign: 'justify', marginBottom: '5px' }}>
        Por fim, clique em "Finalizar": revise os dados a serem gravados e
        escolha entre gravar apenas no Juslabore ou gravar no Juslabore e no
        Google Calendar.
      </p>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          margin: '20px 0',
        }}
      >
        <Zoom>
          <img
            src={recorte3}
            style={{ width: 700, border: '1px solid #CCC', borderRadius: 5 }}
          />
        </Zoom>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          margin: '20px 0',
        }}
      >
        <Zoom>
          <img
            src={recorte4}
            style={{ width: 700, border: '1px solid #CCC', borderRadius: 5 }}
          />
        </Zoom>
      </div>
      <p>
        <strong>Pronto. Evento gravado!</strong>
      </p>
      <br />
      <h3>Como utilizo o Google Calendar?</h3>
      <p style={{ textAlign: 'justify', marginBottom: '5px' }}>
        Para utilizar nossa ferramenta vinculada ao Google Calendar basta estar
        logado em sua conta Google.
      </p>
    </Container>
  );
}
